import { Form, Formik } from 'formik';
import * as Yup from "yup";
import React, { useState } from 'react';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import { patchProductVisitorsNote } from '../../services/product_visitors';
import { toast } from 'react-toastify';
import { getUserId } from '../../helpers/local_storage_helpers';
import { patchShopVisitorsNote } from '../../services/shop_visitors';
import { patchBulkEnquiry, patchFpoEnquiry } from '../../services/enquiries';

function AddFpoNote({ item, onSave }) {

    const validationSchema = Yup.object({
        note: Yup.string().required("Note is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const data = {
                note: values.note,
                attended_by: getUserId(),
            };
            const response = await patchFpoEnquiry({
                data: data,
                id: item.id,
            });
            if (response?.status === 200) {
                onSave();
                toast.success("Note added successfully!");
            } else {
                toast.error("Oops! Something went wrong, please try again.");
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Oops! Something went wrong, please try again.";
            toast.error(errors);
        } finally {
            setSubmitting(false);
        }
    };

    return (<div className="w-full flex-1">
        <StyledHeadingText text="Note" />
        <Formik
            initialValues={{ note: item.note }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting, setFieldValue, values }) => (
                <Form className="space-y-4 my-4">
                    <div className="flex gap-4 flex-col">
                        <InputField
                            label={"Note"}
                            name="note"
                            type="text"
                            placeholder="Enter your Note here..."
                            required
                        />
                        {
                            item.attended_by ?
                                <strong>- Last Saved By: {item.staff_name}</strong> : <></>
                        }
                        <Button
                            type="submit"
                            className="bg-primary text-white px-4 py-2 rounded max-w-32"
                            disabled={isSubmitting}
                        >
                            {"Save"}
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    </div >);
}

export default AddFpoNote;